module.exports = __webpack_public_path__ + "img/PBLACK.6cb0b98e.jpg";